import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'
import Multiselect from 'vue-multiselect'
import _ from "lodash"
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Alerts from "../components/utils/alerts";

Vue.use(VueMask);
var app = new Vue({
    el: '#registerForm',
    data() {
        return {
            userState:{},
            formInit:false,
            step:0,
            steps: [
                { id: 0, name: 'Select a plan', disabled: false },
                { id: 1, name: 'Registration', disabled: false },
                { id: 2, name: 'Business Information', disabled: false },
                { id: 3, name: 'Profile', disabled: false },
                { id: 4, name: 'Payment', disabled: false }
            ],
            productImages: ['images/blog-card-1.png', 'images/services-header.png'],
            products : [],
            selectedProduct:{},
            paymentOption:'month',
            teamsContact: {
                company_name:'',
                full_name:'',
                email:'',
                position:'',
                phone:'',
                agents:0,
                message:'',
                gtoken:''
            },
            corporateFormError: {
                company_name: false,
                full_name: false,
                email: false,
                position: false,
                phone: false,
                agents: false
            },
            user: {
                first_name:'',
                last_name:'',
                email:'',
                phone_number:'',
                phone_number1:'',
                password:''
            },
            registeredUser:{
                first_name: '',
                last_name: '',
                email: '',
                address:'',
                city:'',
                state:'',
                state_id:'',
                zipcode:'',
                practicing:0,
                bio:'',
                fun_facts:'',
                address_visible: true
            },
            formError:{
                first_name: false,
                last_name: false,
                email: false,
                password: false
            },
            accountFormError:{
                address: false,
                city: false,
                state: false,
                zip: false
            },
            emailError:null,
            validated:false,
            pk: process.env.MIX_STRIPE_PUBLISH_KEY,
            intent: '',
            styles: {
                base: {
                    fontSize: "14px",
                    color: "#4A4A4A",
                    ":focus": {
                        color: "#4A4A4A"
                    },
                    "::placeholder": {
                        color: "#92979c"
                    },
                    ":focus::placeholder": {
                        color: "#92979c"
                    }
                },
                invalid: {
                    color: "#D0021B",
                    ":focus": {
                        color: "#D0021B"
                    },
                    "::placeholder": {
                        color: "#D0021B"
                    }
                }
            },
            classes: {
                focus: "focus",
                empty: "empty",
                invalid: "invalid"
            },
            agree: false,
            savedErrors: '',
            showThankYou: false,
            states:[],
            industries:[],
            professions: [],
            profileProducts: [],
            agentProfessions: [],
            agentProducts: [],
            agentIndustries: [],
            profileErrors: {
                professions:false,
                products:false
            },
            billingName: '',
            socialUser:null,
            socialFeedbackWatcher:null,
            addressSuggestion:[],
            pwd:'password',
            working: false,
            custom_directions_link: '',
            recaptchaError:'',
            uuid:'',
            email_verification: {
                showEmailVerificationForm: false,
                codeSent: false,
                status:'',
                error:''
            },
            showPromoCodeForm: false,
            promoCode:'',
            pc_off:null,
            promoErrors:'',
            billingSelectedPlan: {},
            stripe: null,
            stripeInc: false
        }
    },
    components:{
        Multiselect,
        VueGoogleAutocomplete
    },
    computed: {
        activeStep: function() {
            return this.steps[this.step].id
        },
        calculatedPrice: function() {
            return this.getBestPrice(this.selectedProduct)
        },
        addressValue: function() {
            return this.registeredUser.address
        },
        showDiscountedPrice: function() {
            let price = this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price - (this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price*(this.pc_off.percent_off/100))
            if(price == Math.floor(price)) {
                return price
            } else {
                return price.toFixed(2)
            }
        }
    },
    mounted: async function(){
        await this.getProducts()
        await this.getIndustries()
        try { await this.checkUser() }
        finally {
            this.$nextTick(() => {
                this.getStates()
            })
            axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'Accept': 'application/json',
            }
        }
    },
    watch: {
        socialUser(data) {
            if(data.social_id) {
                clearInterval(this.socialFeedbackWatcher)
                localStorage.removeItem('user')
                this.registerUser()
            }
        }
    },
    methods: {
        checkUser: async function() {
            let queryString = window.location.search
            let urlParams = new URLSearchParams(queryString)
            let promo_code = urlParams.get('promo_code')
            if(promo_code) {
                this.promoCode = promo_code
                this.selectedProduct = this.products[0]
                this.selectedProduct.plans.forEach(p => {
                    this.selectedProduct[p.duration.replace("-", "")] = p
                })
                this.addPromoCode()
            }
            this.uuid = urlParams.get('c')
            let api_url = !this.uuid || this.uuid.length < 16 ? '/api/v1/get-profile-data' : '/api/v1/agent-by-slug/'+this.uuid
            await axios.get(window.location.origin + api_url)
                .then(async response => {
                    this.userState = response.data.data                   
                    if(this.userState !== null && this.userState.registration_step) {
                        switch (this.userState.registration_step) {
                            case 1:
                                this.selectedProduct = this.products[0].sub_products[1]
                                this.billingSelectedPlan = this.products[0].sub_products[1]
                                this.paymentOption = 'month'
                                this.selectedProduct.plans.forEach(p => {
                                    this.selectedProduct[p.duration.replace("-", "")] = p
                                })
                                this.step = 2
                                if(this.userState.has_verified == 0) {
                                    this.email_verification.showEmailVerificationForm = true
                                    this.$nextTick(() => {
                                        this.includeCodeVerificationHandling()
                                    })
                                    this.requestEmailVerificationCode(this.userState.uuid)
                                }
                                this.formInit = true
                                break
                            case 2:
                                this.registeredUser = {
                                    first_name: this.userState.first_name,
                                    last_name: this.userState.last_name,
                                    email: this.userState.email,
                                    address:this.userState.address,
                                    city:this.userState.city,
                                    state:this.userState.state_name,
                                    state_id:this.userState.state_id,
                                    zipcode:this.userState.zipcode,
                                    practicing:parseInt(this.userState.agent_detail.experience),
                                    bio:this.userState.bio,
                                    fun_facts:this.userState.awards,
                                    address_visible: this.userState.address_visible == 1
                                }
                                this.agentIndustries.push(this.userState.industry)
                                await this.selectIndustry(this.userState.industry)
                                this.userState.agent_services.forEach(s => {
                                    this.agentProducts.push({id:s.service_id, name:s.service_name})
                                })
                                this.professions.forEach(p => {
                                    this.userState.agent_professions.forEach(pr => {
                                        if(p.id == pr.profession_id) {
                                            this.selectProfession(p)
                                            this.agentProfessions.push(p)
                                        }
                                    })
                                })
                                this.selectedProduct = this.products[0].sub_products[1]
                                this.billingSelectedPlan = this.products[0].sub_products[1]
                                this.paymentOption = 'month'
                                this.selectedProduct.plans.forEach(p => {
                                    this.selectedProduct[p.duration.replace("-", "")] = p
                                })
                                this.step = 4
                                this.steps[0].disabled = true
                                this.steps[1].disabled = true
                                this.formInit = true
                                this.$nextTick(() => {
                                    this.initStripe()
                                })
                                break
                        }
                    } else if(this.userState !== null && (this.uuid && this.uuid.length > 0)) {
                        this.user = {
                            first_name: this.userState.first_name,
                            last_name: this.userState.last_name,
                            email: this.userState.email,
                            phone_number: this.userState.phone_number
                        }
                        if(this.userState.industry?.name){
                            this.agentIndustries.push(this.userState.industry)
                            await this.selectIndustry(this.userState.industry)
                        }
                        if(this.userState.agent_services.length > 0){
                            this.userState.agent_services.forEach(s => {
                                this.agentProducts.push({id:s.service_id, name:s.service_name})
                            }) 
                        }
                        if(this.userState.agent_professions.length > 0){
                            this.professions.forEach(p => {
                                this.userState.agent_professions.forEach(pr => {
                                    if(p.id == pr.profession_id) {
                                        this.selectProfession(p)
                                        this.agentProfessions.push(p)
                                    }
                                })
                            })
                        }
                        this.selectedProduct = this.products[0]
                        this.selectedProduct.plans.forEach(p => {
                            this.selectedProduct[p.duration.replace("-", "")] = p
                        })
                        this.step = 1
                        this.formInit = true
                    }
                }).catch(err => {
                    this.formInit = true
                })
        },
        validateFields: function(d) {
            let error = false
            switch (d.type) {
                case 'length':
                    error = d.value.length < d.param
                    break
                case 'amount':
                    error = d.value < d.param
                    break
                case 'same':
                    error = d.value1 != d.value2
                    break
                case 'email':
                    error = !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(d.value)
                    break
            }
            return error
        },
        getProducts: async function() {
            await axios.get(window.location.origin +'/api/v1/get-products')
                .then(response => {
                    let p = {
                        id:0,
                        title:"Individual",
                        sub_products:[]
                    }
                    response.data.products.filter(p => p.plans[0].status == 'active').forEach((pr,index) => {
                        pr.plans.forEach(pl => {
                            pl.selected = false
                        })
                        pr.selected = index == 1
                        p.sub_products.push(pr)
                    })
                    this.products.push(p)
                    this.products.push({
                        id:100,
                        title:"Enterprise",
                        sub_products:[],
                        plans:[],
                        description: `<p>This account type is for organizations that wish to have more than one profile.
                        There is no limit to the number of profiles under an Enterprise account.</p>
                        <p><strong>What is included:</strong></p>
                        <ul>
                            <li>Corporate dashboard to administer profiles/listings.</li>
                            <li>Individual profile logins and dashboards for each profile holder.</li>
                            <li>Search-engine-friendly profile pages </li>
                            <li>Profile listings on Introz.com</li>
                            <li>Unique URLs for each profile landing page</li>
                            <li>Video on landing pages and listings</li>
                        </ul>
                        <p><strong>Available options:</strong></p>
                        <ul>
                            <li>Custom URL for all profiles pages and dashboard</li>
                            <li>Branded landing pages </li>
                            <li>Hosted white-labeled searchable listings engine</li>
                            <li>Dedicated account manager</li>
                            <li>Contact forms connected to corporate CRM</li>
                        </ul>`
                    })
                })
        },
        getIndustries: async function() {
            await axios.get(window.location.origin +'/api/v1/industries')
                .then(response => {
                    this.industries = response.data.data
                })
        },
        getProfessions: async function(id) {
            await axios.get(window.location.origin +'/api/v1/professions',{params:{industry_id:id}})
                .then(response => {
                    this.professions = response.data.data
                })
        },
        getProductImage: function (index) {
            if(index != undefined) {
                return window.location.origin+'/'+this.productImages[index]
            } else {
                let i = ''
                this.products.forEach((p,index) => {
                    p.id == this.selectedProduct.id ? i = index : ''
                })
                return window.location.origin + '/' + this.productImages[i]
            }

        },
        scrollTo(refName) {
            var el = this.$refs[refName]
            if (el) {
                el.scrollIntoView({behavior: 'smooth'});
            }
        },
        selectPlan: function (opt,product) {
            if(product.title) {
                this.recaptchaError = ''
                if(product.title != 'Enterprise') {
                    this.products[0].sub_products.forEach(p => {
                        if(p.id == product.id) {
                            this.selectedProduct = p
                            this.selectedProduct.plans.forEach(p => {
                                this.selectedProduct[p.duration.replace("-", "")] = p
                            })
                        }
                    })
                    this.paymentOption = 'month'
                    if(this.step == 4) {
                        // if billing step check if stripe needs to be reinitialized
                        if(!this.stripeInc && this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price > 0) {
                            this.$nextTick(() => {
                                this.initStripe()
                            })
                        } else if (this.stripeInc && this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price == 0) {
                            this.$nextTick(() => {
                                this.initStripe()
                            })
                        }
                    }
                } else {
                    this.selectedProduct = this.products[1]
                }
                if(this.step == 0 && opt) {
                    this.selectedProduct.title == 'Enterprise' ? this.navSteps(10) : this.navSteps(1)
                }
            }
        },
        selectProduct: function(id) {
            this.products[0].sub_products.forEach((product) => {
                if(product.id == id) {
                    product.selected = true
                    this.billingSelectedPlan = product
                    this.selectPlan(false,product)
                } else {
                    product.selected = false
                }
            })
        },
        navSteps: async function(id) {
            let status = true
            if(id == 2 && !this.userState.registration_step) { status = await this.registerUser() }
            if(status) {
                this.step = id
                this.$nextTick(() => {
                    this.scrollTo('formTop')
                    if (id == 4) {
                        this.$nextTick(() => {
                            this.initStripe()
                        })
                    }
                    if (id == 1) {
                        this.socialFeedbackWatcher = setInterval(() => {
                            if(localStorage.getItem('user') != null && localStorage.getItem('user') != '') {
                               this.socialUser = JSON.parse(localStorage.getItem('user'))
                            }
                        }, 2000)
                    }
                })
            }
        },
        sendContacts: async function() {
            this.corporateFormError = {
                company_name: false,
                full_name: false,
                email: false,
                position: false,
                phone:false,
                agents: false
            }
            let valid = true
            this.corporateFormError.company_name = this.validateFields({ type: 'length', value: this.teamsContact.company_name, param: 1 })
            this.corporateFormError.full_name = this.validateFields({ type: 'length', value: this.teamsContact.full_name, param: 1 })
            this.corporateFormError.email = this.validateFields({ type: 'email', value: this.teamsContact.email })
            this.corporateFormError.position = this.validateFields({ type: 'length', value: this.teamsContact.position, param: 1 })
            this.corporateFormError.phone = this.validateFields({ type: 'length', value: this.teamsContact.phone, param: 10 })
            this.corporateFormError.agents = this.validateFields({ type: 'amount', value: this.teamsContact.agents, param: 1 })

            if(Object.values(this.corporateFormError).indexOf(true) > -1) { valid = false }

            let captcha = await this.checkRecaptcha()

            if(!captcha) {
                this.recaptchaError = 'Looks like something wen’t wrong. Please contact support@popintros.com for assistance.'
                return false
            }

            if (!valid) {
                return false
            } else {
                this.teamsContact.gtoken = captcha
                await axios.post(window.location.origin + '/api/v1/submit-lead',this.teamsContact)
                    .then(response => {
                        this.showThankYou = true
                        this.$nextTick(() => {
                            this.scrollTo('formTop')
                        })
                    })
                    .catch(err => {
                        console.log('error')
                    })

            }

        },
        validateEmail: async function() {
            this.emailError = false
            if(this.user.email.length > 0){
               if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.user.email)) {
                    this.emailError = true
                } else if (!this.uuid) {
                    await axios.post(window.location.origin + '/api/v1/check-email',{email:this.user.email})
                        .then(response => {
                            this.emailError = response.data.exist
                        })
                }
            }
        },
        registerUser: async function() {
            if (!this.userState.social_reg) {
            // if (this.socialUser == null || !this.socialUser.social_id) {
                this.formError = {
                    first_name: false,
                    last_name: false,
                    email: false,
                    phone_number: false,
                    password: false
                }
                this.validated = true
                await this.validateEmail()

                this.formError.first_name = this.validateFields({ type: 'length', value: this.user.first_name, param: 1 })
                this.formError.last_name = this.validateFields({ type: 'length', value: this.user.last_name, param: 1 })
                this.formError.email = this.validateFields({ type: 'email', value: this.user.email })
                this.formError.phone_number = this.validateFields({ type: 'amount', value: this.user.phone_number, param: 10 })
                this.formError.password = this.validateFields({ type: 'length', value: this.user.password, param: 8 })

                if(Object.values(this.formError).indexOf(true) > -1) { this.validated = false }

                let captcha = await this.checkRecaptcha()

                if(!captcha) {
                    this.recaptchaError = 'Looks like something wen’t wrong. Please contact support@popintros.com for assistance.'
                    return false
                }

                if(!this.validated) {
                    return false
                } else {
                    let data = {
                        first_name: this.user.first_name,
                        last_name: this.user.last_name,
                        email: this.user.email,
                        password: this.user.password,
                        password_confirmation: this.user.password,
                        phone_number: this.user.phone_number,
                        gtoken:captcha
                    }
                    this.uuid ? data.uuid = this.uuid : ''
                    await axios.post(window.location.origin + '/api/v1/create-user', data)
                        .then(response => {
                            this.registeredUser = response.data.data
                            this.step = 2
                            this.steps[0].disabled = true
                            this.steps[1].disabled = true
                            this.validated = true
                            this.registeredUser.first_name = this.user.first_name
                            this.registeredUser.last_name = this.user.last_name
                            if(!this.uuid || this.userState?.has_verified == 0) {
                                this.email_verification.showEmailVerificationForm = true
                                this.requestEmailVerificationCode(this.registeredUser.uuid)
                                this.$nextTick(() => {
                                    this.scrollTo('formTop')
                                    this.includeCodeVerificationHandling()
                                })
                            }
                            gtag("event", "complete_registration_user_email", {
                                'user_id': this.user.id
                            })
                        }).catch(err => {
                            this.recaptchaError = err.response.data.message
                        })
                }
            } else {
                let captcha = await this.checkRecaptcha()

                if(!captcha) {
                    this.recaptchaError = 'Looks like something wen’t wrong. Please contact support@popintros.com for assistance.'
                    return false
                }

                let data = {
                    uuid: this.userState.uuid,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    phone_number: this.user.phone_number,
                    gtoken:captcha
                };

                await axios.post(window.location.origin + '/api/v1/create-user', data)
                    .then(response => {
                        this.registeredUser = response.data.data
                        this.step = 2
                        this.steps[0].disabled = true
                        this.steps[1].disabled = true
                        this.validated = true
                        this.$nextTick(() => {
                            this.scrollTo('formTop')
                        })
                        gtag("event", "complete_registration_user_social", {
                            'user_id': this.user.id
                        })
                    })

                // await axios.post(window.location.origin + '/api/v1/create-user', this.socialUser)
                //     .then(response => {
                //         this.registeredUser = response.data.data
                //         this.step = 2
                //         this.steps[0].disabled = true
                //         this.steps[1].disabled = true
                //         this.validated = true
                //         this.$nextTick(() => {
                //             this.scrollTo('formTop')
                //         })
                //         gtag("event", "complete_registration_user_social", {
                //             'user_id': this.user.id
                //         })
                //     })
            }
        },
        checkRecaptcha: async function() {
            this.recaptchaError = ''
            let grck = document.getElementById('grck').value
            let gtoken = ''
            await grecaptcha.execute(grck, {action: 'submit'}).then(async (token) => {
                gtoken = token
            })
            return gtoken
        },
        getStates: async function() {
            await axios.get(process.env.MIX_APP_URL + '/api/v1/get-states')
                .then(res => {
                    this.states = res.data.data;
                    this.$nextTick(() => {
                        this.scrollTo('formTop')
                    })
                })
        },
        getAddressData: function(e) {
            this.registeredUser.zipcode = e.postal_code
            this.registeredUser.city = e.locality
            this.registeredUser.address = e.street_number ? e.street_number + ' ' + e.route : e.route
            this.states.forEach(state => {
                if(state.state_code == e.administrative_area_level_1){
                    this.registeredUser.state_id = state.id
                    this.registeredUser.state = state.state_name
                }
            })
            this.registeredUser.lat = e.latitude;
            this.registeredUser.long = e.longitude;
            // this.custom_directions_link = `https://maps.google.com/maps?q=loc:${e.latitude},${e.longitude}`

            document.getElementById('map').value = this.registeredUser.address
        },
        updateAccountInfo: async function() {
            if(!this.registeredUser.address || this.registeredUser.address.length == 0) {
                this.registeredUser.address = document.getElementById('map').value
            }
            if(!this.registeredUser.state && this.registeredUser.state_id != '') {
                this.states.forEach(state => {
                    if(state.id == this.registeredUser.state_id){
                        this.registeredUser.state = state.state_name
                    }
                })
            }
            this.accountFormError = {
                address: false,
                city: false,
                state: false,
                zipcode: false,
                phone: false
            }
            let valid = true
            this.accountFormError.address = this.validateFields({ type: 'length', value: this.registeredUser.address, param: 1 })
            this.accountFormError.city = this.validateFields({ type: 'length', value: this.registeredUser.city, param: 1 })
            this.accountFormError.state = this.validateFields({ type: 'length', value: this.registeredUser.state, param: 1 })
            this.accountFormError.zipcode = this.validateFields({ type: 'length', value: this.registeredUser.zipcode, param: 5 })
            if(this.socialUser) {
                this.accountFormError.phone_number1 = this.validateFields({ type: 'amount', value: this.user.phone_number1, param: 10 })
            }

            if (Object.values(this.accountFormError).indexOf(true) > -1) { valid = false }

            if (!valid) {
                return false
            } else {
                this.step = 3;
                this.validated = true;
                this.$nextTick(() => {
                    this.scrollTo('formTop')
                });
                gtag("event", "complete_registration_business", {
                    'user_id': this.user.id
                });
            }
        },
        addProfession: function(p) {
            let hasNew = false
            this.professions.forEach(prof => {
                if (prof.new) { hasNew = true }
            })
            if(!hasNew){
                const profession = {
                    name: p,
                    new: true,
                    services: []
                }
                this.professions.push(profession)
                this.profileProducts.push(profession)
                this.agentProfessions = []
                this.agentProfessions.push(profession)
            }
        },
        selectIndustry: async function(p) {
            await this.getProfessions(p.id)
        },
        selectProfession: function(p) {
            this.profileProducts.push(p)
        },
        unselectIndustry: function() {
            this.agentIndustries = []
            this.agentProfessions = []
            this.profileProducts = []
        },
        unselectProfession: function(p) {
            let i
            this.profileProducts.forEach((prod,index) => {
                if(prod.id == p.id) { i = index }
            })
            this.profileProducts.splice(i, 1)
            this.agentProducts = this.agentProducts.filter(function(obj) {
                let filter = true
                p.services.forEach(pr => {
                    if(pr.id == obj.id) { filter = false}
                })
                return filter
            })
        },
        addProduct: function(p) {
            this.profileProducts.forEach(prof => {
                if(prof.new) { prof.services.push({ productName: p }) }
            })
            this.agentProducts.push({ productName: p })
        },
        updateProfileInfo: async function(){
            this.profileErrors = {
                industries: false,
                professions: false,
                products: false
            }
            let valid = true
            this.profileErrors.industries = this.validateFields({ type: 'length', value: this.agentIndustries, param: 1 })
            this.profileErrors.professions = this.validateFields({ type: 'length', value: this.agentProfessions, param: 1 })
            this.profileErrors.products = this.validateFields({ type: 'length', value: this.agentProducts, param: 1 })

            if (Object.values(this.profileErrors).indexOf(true) > -1) { valid = false }

            if(!valid) {
                return false
            } else {

                let data = {
                    id: this.registeredUser.id,
                    first_name: this.registeredUser.first_name,
                    last_name: this.registeredUser.last_name,
                    street_address: this.registeredUser.address,
                    city: this.registeredUser.city,
                    state: this.registeredUser.state_id,
                    zip: this.registeredUser.zipcode,
                    experience: this.registeredUser.practicing,
                    bio: this.registeredUser.bio,
                    awards: this.registeredUser.fun_facts,
                    address_visible: this.registeredUser.address_visible,
                    agent_industries: [],
                    agent_professions: [],
                    agent_services: [],
                    license_numbers:[],
                    profession_id:this.agentProfessions[0].id,
                    industry_id:this.agentIndustries[0].id,
                    custom_directions_link: this.custom_directions_link,
                    lat: this.registeredUser.lat,
                    long: this.registeredUser.long
                }
                if(this.socialUser) {
                    data.phone_number = this.user.phone_number1
                }
                this.agentIndustries.forEach(p => {
                    data.agent_industries.push(p.id)
                })
                this.agentProfessions.forEach(p => {
                    data.agent_professions.push(p.id)
                })
                this.agentProducts.forEach(p => {
                    data.agent_services.push(p.id)
                })
                await axios.post(window.location.origin + '/api/v1/update-user', data)
                    .then(response => {
                        this.navSteps(4);
                        this.$nextTick(() => {
                            this.scrollTo('formTop')
                        });
                        gtag("event", "complete_registration_profile", {
                            'user_id': this.user.id
                        });
                    })
            }
        },
        initStripe: function () {
            if(this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price > 0) {
                this.stripeInc = true
                this.stripe = Stripe(this.pk)
                const elements = this.stripe.elements()
                var elementStyles = this.styles
                var elementClasses = this.classes
                var cardNumber = elements.create("cardNumber", {
                    style: elementStyles,
                    classes: elementClasses
                })
                cardNumber.mount("#card-number")
                var cardExpiry = elements.create("cardExpiry", {
                    style: elementStyles,
                    classes: elementClasses
                })
                cardExpiry.mount("#card-expiry")
                var cardCvc = elements.create("cardCvc", {
                    style: elementStyles,
                    classes: elementClasses
                })
                cardCvc.mount("#card-cvc")
                this.registerElements(
                    [cardNumber, cardExpiry, cardCvc],
                    "paymentform"
                )
            } else {
                this.stripe = null
                this.stripeInc = false
            }
            const cardButton = document.getElementById('card-button')
            cardButton.removeEventListener('click', () => {})
            cardButton.addEventListener('click', async (e) => {
                this.working = true
                if (this.billingName.length > 0 && this.agree && this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price > 0) {
                    //regular plan
                    this.stripe.createToken(cardNumber).then((result) => {
                        if (!result.error) {
                            var cardHolderName = document.getElementById('card-holder-name').value
                            this.stripe.createPaymentMethod({
                                type: 'card',
                                card: cardNumber,
                                billing_details: {
                                    name: cardHolderName,
                                }
                            }).then(async (result) => {
                                if (result.error) {
                                    console.log("Something went wrong. please fill all the required fields and try again");
                                    let message = result.error.message;
                                    (new Alerts('Subscription')).error(message ? message : 'Some error occurred')
                                    this.working = false
                                } else {
                                    var card = result.paymentMethod
                                    let data = {
                                        card, plan_id: this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].id
                                    }
                                    if(this.pc_off && this.pc_off.stripe_id) {
                                        data.coupon_id = this.pc_off.stripe_id
                                    }
                                    await axios.post(addNewCardUrl, data)
                                        .then(response => {
                                            gtag("event", "complete_registration_billing", {
                                                'user_id': this.user.id
                                            })
                                            window.location = window.location.origin + '/dashboard'
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                            let message = err.data.message ? err.data.message : 'Some error occurred'
                                            (new Alerts('Subscription')).error(message)
                                            this.working = false
                                        })
                                }
                                })
                        } else {
                            let message = result.error.message;
                            (new Alerts('Subscription')).error(message ? message : 'Some error occurred')
                            this.working = false
                        }
                    })
                } else if(this.billingName.length === 0 && this.agree && this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].price == 0) {
                    //free plan
                    let data = {
                        card:null, plan_id: this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].id
                    }
                    await axios.post(addNewCardUrl, data)
                        .then(response => {
                            gtag("event", "complete_registration_billing", {
                                'user_id': this.user.id
                            })
                            window.location = window.location.origin + '/dashboard'
                        })
                        .catch((err) => {
                            console.log(err);
                            let message = err.data.message ? err.data.message : 'Some error occurred'
                            (new Alerts('Subscription')).error(message)
                            this.working = false
                        })
                } else {
                    this.savedErrors = this.agree ? 'Enter Name on card' : 'You must agree with Terms and Conditions'
                    this.working = false
                }
            })
        },
        registerElements: function (elements, exampleName) {
            elements.forEach((element, idx) => {
                element.on("change", (event) => {
                    var errorElement = document.getElementById("card-errors")
                    if (event.error) {
                        this.savedErrors = event.error.message
                    } else {
                        this.savedErrors = null
                    }
                })
            })
        },
        getBestPrice(product){
            const monthlyPlan = product.plans.filter((plan) => plan.duration === 'month')[0]
            const lifetimePlan = product.plans.filter((plan) => plan.duration === 'lifetime')[0]
            const yearlyPlan = product.plans.filter((plan) => plan.duration === 'year')[0]

            if (monthlyPlan) {
                return Math.floor(monthlyPlan.price)
            } else if(lifetimePlan) {
                return Math.floor(lifetimePlan.price)
            } else if (yearlyPlan) {
                return Math.floor(yearlyPlan.price/12)
            }
        },
        includeCodeVerificationHandling() {
            const els = (sel, par) => (par || document).querySelectorAll(sel)

            els(".verification-code").forEach((elGroup) => {

                const elsInput = [...elGroup.children]
                const len = elsInput.length
                
                const handlePaste = (ev) => {
                    const clip = ev.clipboardData.getData('text')
                    const pin = clip.replace(/\s/g, "")
                    const ch = [...pin]
                    elsInput.forEach((el, i) => el.value = ch[i]??"")
                    elsInput[pin.length - 1].focus()
                };

                const handleInput = (ev) => {
                    const elInp = ev.currentTarget
                    const i = elsInput.indexOf(elInp)
                    if (elInp.value && (i+1) % len) elsInput[i + 1].focus()
                };
                
                const handleKeyDn = (ev) => {
                    const elInp = ev.currentTarget
                    const i = elsInput.indexOf(elInp)
                    if (!elInp.value && ev.key === "Backspace" && i) elsInput[i - 1].focus()
                };
                
                
                elsInput.forEach(elInp => {
                    elInp.addEventListener("paste", handlePaste)
                    elInp.addEventListener("input", handleInput)
                    elInp.addEventListener("keydown", handleKeyDn)
                })
            
            })
        },
        requestEmailVerificationCode: async function (uuid,status) {
            if(uuid == '') {
                if(this.userState.uuid && this.userState.uuid.length > 0) {
                    uuid = this.userState.uuid
                } else if(this.registeredUser.uuid && this.registeredUser.uuid.length > 0) {
                    uuid = this.registeredUser.uuid
                } else {
                    uuid = this.uuid
                }
            }
            let data = {
                uuid:uuid,
                channel:'email'
            }
            await axios.post(window.location.origin + '/api/v1/generate-otp', data)
                .then(response => {
                    this.email_verification.codeSent = true
                    this.email_verification.status = status
                }).catch(err => {
                    console.log(err.response.data.message)
                    this.email_verification.error = err.response.data.message
                })
        },
        verifyEmailValidationCode: async function () {
            let otp_inputs = document.querySelectorAll('.code-input')
            let otp = ''
            for (var i = 0; i < otp_inputs.length; i++) {
                otp = otp+otp_inputs[i].value
            }

            if(otp.length != 5) {
                this.email_verification.error = 'Please enter 6 digits verification code'
                return false
            } else {
                let uuid = ''
                if(this.userState.uuid && this.userState.uuid.length > 0) {
                    uuid = this.userState.uuid
                } else if(this.registeredUser.uuid && this.registeredUser.uuid.length > 0) {
                    uuid = this.registeredUser.uuid
                } else {
                    uuid = this.uuid
                }
                let data = {
                    uuid:uuid,
                    otp:otp
                }
                await axios.post(window.location.origin + '/api/v1/verify-otp', data)
                .then(response => {
                    this.email_verification.codeSent = false
                    this.email_verification.showEmailVerificationForm = false
                }).catch(err => {
                    console.log(err.response.data.message)
                    this.email_verification.error = 'Oops. Looks like that code didn’t match. Please try again or request a new code'
                })
            }
        },
        addPromoCode: async function() {
            this.working = true
            this.promoErrors = ''
            if(this.promoCode.length == 0) {
                this.promoErrors = 'Please enter a promo code.'
                this.working = false
            } else {
                let data = {
                    plan_id: this.selectedProduct.plans.filter((plan) => plan.duration === this.paymentOption)[0].id,
                    coupon_id: this.promoCode
                }
                await axios.post(window.location.origin + '/api/v1/check-valid-coupon', data)
                .then(response => {
                    if(response.data.valid) {
                        this.pc_off = response.data
                        this.showPromoCodeForm = false
                    } else {
                        this.promoErrors = 'Invalid promo code'
                    }
                }).catch(err => {
                    console.log(err.response.data.message)
                    this.promoErrors = 'Something went wrong'
                })
                this.working = false
            }
        },
        planBestPrice: function(product) {
            let plan = {}

            product.plans.forEach(p => {
                if (p.duration == 'month') {
                    plan = p
                }
            })
            return Math.round(plan.price * 100) / 100
        },
    }
})
